import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import {
  IResult,
} from "../../../../../common/interfaces";
import { environment as env } from "../../../../../../environments/environment.prod";
import { AbstractService } from "app/services/abstract.service";
import { IUpdateSubRoute } from "../interfaces/update-sub-route.interface";
import { ICreateSubRouteItinerary } from "./interfaces/create-route-itinerary.interface";
import SubRouteItineraryAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-itinerary/sub-route-itinerary.entity";

const apiUrl = env.API_ROUTING_URL;
const moduleName = "sub_route_itinerary_alternative";

@Injectable({
  providedIn: "root",
})
export class SubRouteItineraryAlternativeService extends AbstractService<
SubRouteItineraryAttributes,
ICreateSubRouteItinerary,
  IUpdateSubRoute
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findBySubRouteId(subRouteId: string): Observable<IResult<SubRouteItineraryAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${subRouteId}`;
    return this.http.get<IResult<SubRouteItineraryAttributes>>(API_URL);
  }

}
